/**
 * ダッシュボード「カレンダー・TODO」とシフト確定画面で共有する、予定の取得・日付別集計ヘルパー。
 * 予定の元データは events（手動）と /events/auto（話数締切・支払期日・入金予定の合成）。
 * 予定判定ロジックを二重に持たないため、両画面ともここを経由する（読み取り専用）。
 */
import { api } from '../api/client'

export type ScheduleEvent = {
  id?: string
  event_date?: string
  due_date?: string
  title: string
  event_type?: string
  auto_type?: string
  memo?: string | null
  is_done?: number
  is_auto?: boolean
  [k: string]: any
}

export async function fetchMonthScheduleEvents(ym: string): Promise<{ events: ScheduleEvent[]; autoEvs: ScheduleEvent[] }> {
  const [events, autoEvs] = await Promise.all([
    api.events.list(ym),
    api.autoEvents.list(ym).catch(() => []),
  ])
  return { events, autoEvs }
}

/** YYYY-MM-DD をキーに予定をまとめる（日付は保存済みのJST日付文字列をそのまま使う） */
export function groupEventsByDate(list: ScheduleEvent[]): Map<string, ScheduleEvent[]> {
  const map = new Map<string, ScheduleEvent[]>()
  for (const e of list) {
    const d = (e.event_date ?? e.due_date ?? '').slice(0, 10)
    if (!map.has(d)) map.set(d, [])
    map.get(d)!.push(e)
  }
  return map
}
